import { LayoutConfigBuilder } from '../../../layouts/default-layout/builders/layout-config.builder';
import { LayoutConfigPresets } from '../../../layouts/default-layout/models/layout-structures.models';

export enum LearningJourneyProgressionRoutesConfig {
	LJ_BASE_URL = 'learning-journeys',
	LJ_PROGRESSION_BASE_URL = 'learning-journey-progression',
	LJ_PROGRESSION_CONTENT_DETAILS_SEGMENT = ':workflow_id/:version_id/:user_id/content-details/:source_object_id',
	LJ_PROGRESSION_DETAILS_ID_VERSION_USER_ENROLLMENT_SEGMENT = ':workflow_id/:version_id/:user_id/:enrollment_id',
	LJ_PROGRESSION_DETAILS_SEGMENT = 'details'
}

export const layoutConfig = new LayoutConfigBuilder(LayoutConfigPresets.default)
	.setBodyCssClasses(['bg--white'])
	.showDefaultSubHeader(false)
	.setContentCssClasses(['wrap--no-subheader'])
	.setHideAdminNav(true)
	.setAdminWrapCssClasses(['admin-wrap--no-sidenav'])
	.build();
